<template>
  <div>
      <div class="jc-page-content">
      <div class="jc-panel-padding">
        <div class="jc-container-table">
          <div class="jc-container-table-actionBar">
            <jc-form class="jc-table-actionBar-item" :inline="true" :model="grantSearchParams">             
              <jc-form-item :label="$t('代金券编码_')">
                <jc-input v-model.trim="grantSearchParams.number"></jc-input>
              </jc-form-item>
              <jc-form-item :label="$t('代金券有效时间_')">
                <jc-date-picker v-model="daterange"
                                type="daterange"
                                >
                </jc-date-picker>
              </jc-form-item>
               <jc-form-item :label="$t('发放时间_')">
                <jc-date-picker v-model="createTime"
                                type="daterange"
                                >
                </jc-date-picker>
              </jc-form-item>
              <jc-form-item :label="`${$t('领取账号')}${$t('：')}`">
                <jc-input v-model.trim="grantSearchParams.pin"></jc-input>
              </jc-form-item>
              <jc-form-item :label="$t('状态_')" style="margin-left: 0px;">
               <jc-select :placeholder="$t('请选择')" v-model="grantSearchParams.statusIndex">
                    <jc-option v-for="(item,index) in STATUS_MAP" :key="index" :label="item.label" :value="item.value"></jc-option>
                </jc-select>
              </jc-form-item>
              <jc-form-item>
                <jc-button @click="query()" type="primary">{{ $t('查询')}} </jc-button>
              </jc-form-item>
            </jc-form>
            
          </div>
           <jc-table style="width:100%" class="grantLoading" :data="grantList">
              <jc-table-column :label="$t('代金券编码')" :min-width="'11'" prop="number"></jc-table-column>
              <jc-table-column :label="$t('金额_元_')" :min-width="'9'">
                <template scope="scope" >{{scope.row.fee | formatMoney}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('余额_元_')" :min-width="'9'">
                <template scope="scope" >{{scope.row.balance | formatMoney}}</template>
              </jc-table-column>
             <jc-table-column :label="$t('代金券有效时间')" width="180">
                <template scope="scope" >{{ scope.row.validStartTime + $t('至')}}<br/>{{scope.row.validEndTime}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('领取账号')" min-width="12" prop="pin"></jc-table-column>
              <jc-table-column :label="$t('发放时间')" width="90" prop="createTime">
                <template scope="scope" >{{scope.row.createTime}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('状态')" min-width="8" prop="statusIndex">
                <template scope="scope" >{{scope.row.statusIndex | filterQuotaCouponStatus}}</template>
              </jc-table-column>
              <jc-table-column :label="$t('计费方式')" min-width="10" prop="billingType" :show-overflow-tooltip='true'>
                <template scope="scope" > 
                  {{scope.row.billingType | filterBillingType}}</template>
              </jc-table-column>
              <jc-table-column   :label="$t('支持地域')" min-width="10" :show-overflow-tooltip='true'>
                <template slot-scope="scope" >
                  {{scope.row.region | filterRegion}}
                </template>
              </jc-table-column>
              <jc-table-column :label="$t('产品线')" min-width="12" prop="appName" :show-overflow-tooltip='true'>
                <template scope="scope" >
                  {{scope.row.appName | filterAppcode}}</template>
              </jc-table-column>
            </jc-table>
            <div class="btnDiv cl">
              <jc-pagination align="right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="grantSearchParams.currentPage"
                :page-sizes="[10, 20,50]"
                :page-size="grantSearchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="grantTotal">
              </jc-pagination>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IS_OR_NOT, STATUS_MAP } from '@/utils/constant.js'
import { queryCouponList } from '@/api/coupon-api.js'
import { getDate } from '@/utils'

export default {
  name: 'quotaRecord',
  data() {
    return {
      STATUS_MAP,
      IS_OR_NOT,
      grantSearchParams: {
        quotaNumber: null, //代金券编码
        quotaPin: null, //代金券领取人
        status: null, //代金券状态
        validTimeBegin: null, //有效时间开始
        validTimeEnd: null, //有效时间结束
        createTimeBegin: null, //发放开始时间
        createTimeEnd: null, // 发放结束是啊斤
        currentPage: 1, //当前页
        pageSize: 10 //页大小
      },
      daterange: [],
      createTime: [],
      grantList: [],
      grantTotal: 0
    }
  },
  watch: {
    daterange(curVal) {
      this.grantSearchParams.validTimeBegin =
        (curVal[0] && getDate(new Date(curVal[0])).ymd + ' 00:00:00') || ''
      this.grantSearchParams.validTimeEnd =
        (curVal[1] && getDate(new Date(curVal[1])).ymd + ' 23:59:59') || ''
    },
    createTime(curVal) {
      this.grantSearchParams.createTimeBegin =
        (curVal[0] && getDate(new Date(curVal[0])).ymd + ' 00:00:00') || ''
      this.grantSearchParams.createTimeEnd =
        (curVal[1] && getDate(new Date(curVal[1])).ymd + ' 23:59:59') || ''
    }
  },
  methods: {
    async query() {
      try {
        let {
          body: {
            result: { data, pageInfo }
          }
        } = await queryCouponList(this.grantSearchParams)
        this.grantList = this.handleTableData(data) || []
        this.grantTotal = pageInfo.totalRecord
      } catch (e) {
        this.grantList = []
        this.grantTotal = 0
      }
    },
    handleTableData(data) {
      let isExpired = false
      data &&
        data.map(item => {
          let date =
            item.validEndTime &&
            new Date(item.validEndTime) &&
            new Date(item.validEndTime).getTime()
          isExpired = Date.now() > date || !(item.balance >= 0.01)
          item.isExpired = isExpired
        })
      return data
    },
    handleSizeChange(_val) {
      this.grantSearchParams.currentPage = 1
      this.grantSearchParams.pageSize = _val
      this.query()
    },

    handleCurrentChange(_val) {
      this.grantSearchParams.currentPage = _val
      this.query()
    }
  },
  created() {
    this.query()
  }
}
</script>
<style>
.form-tablelabel {
  margin-right: 10px;
}
</style>
